var coupon = ( function ( $ ) {

	var $toggle;

	var _init = function() {
		$toggle = $( '.coupon-toggle' );

		if ( $toggle.length > 0 ) {
			$toggle.on( 'click', _toggle_coupon_form );
		}
	};

	var _toggle_coupon_form = function( e ) {
		e.preventDefault();
		e.stopImmediatePropagation();

		$( '.coupon-form' ).slideToggle();
	};

	$( document ).ready( _init );

} )( jQuery );

module.exports = coupon;